import isLive from './Carbon.Frontend/Resources/Private/Assets/Scripts/isLive';
import html from './Carbon.Frontend/Resources/Private/Assets/Scripts/html';
import language from './Carbon.Frontend/Resources/Private/Assets/Scripts/language';
import domReady from './Carbon.Frontend/Resources/Private/Assets/Scripts/domReady';
import { onReady, onReadyRun } from './Scripts/OnReadyRun';
import Gator from 'gator';

window.Gator = Gator;
window._gg = {
    html,
    isLive,
    language,
    domReady,
    onReady,
    onReadyRun,
};
